module.exports = __webpack_public_path__ + "img/line-chart.b55b2549.svg";